// *******************************************************************************
// 1.0 - Change iframe url in lightbox
// *******************************************************************************

const videoElement = document.querySelectorAll('.video-block');
const videoiFrameElement = document.querySelectorAll('.light-box-single__video iframe')[0];

Array.prototype.forEach.call(videoElement, (element) => {
  element.addEventListener('click', (ev) => {
    const videoId = ev.currentTarget.getAttribute('data-video');
    videoiFrameElement.src = `https://www.youtube.com/embed/${videoId}`;
    ev.preventDefault();
  });
});
